import React from 'react';
import FeaturedItem from './FeaturedItem';
import FeaturedStory from './FeaturedStory';
import FeaturedEvent from './FeaturedEvent';

const FeaturedSection = ({ featured_section }) => {
  if (!featured_section) {
    return null;
  }

  const { item, story, event, backup_item } = featured_section;

  return (
    <section className="featured-section">
      {item && <FeaturedItem item={item} />}
      {story && <FeaturedStory story={story} />}
      {event && <FeaturedEvent event={event} />}
    </section>
  );
};

export default FeaturedSection;
